import { userEntity } from "../domain/entities/user_entity";
import { userCredentialsEntity } from "../domain/entities/user_credentials_entity"
import http from "../../../plugins/http-common"
// import i18n from "../../../i18n";

export const HttpUserRepository = {
  model: userEntity,
  model_credentials: userCredentialsEntity,
  async donwload_credentials(data) {
    const res = await http.post('user/credentials', data)

    return res;
  },
};